import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { RenewVehicleRepository } from "../Repositories/renew-vehicle.repository";
import { RenewVehicleFilter } from "../Types/Interfaces/renew-vehicle-filter.interface";
import { RenewVehicle, RenewVehicleResponse } from "../Types/Interfaces/renew-vehicle.interface";
import { VIN } from "@RGVSI/Shared/Types/Interfaces/vin.interface";

@Injectable({
  providedIn: "root",
})
export class RenewVehicleService {
  constructor(private RenewVehicleRepository: RenewVehicleRepository, private fileHandlerService: FileHandlerService) {}

  public getStatus(): Observable<DropdownOption[]> {
    return this.RenewVehicleRepository.getStatus();
  }

  public getChassis(policy: string): Observable<VIN[]> {
    return this.RenewVehicleRepository.getChassis(policy);
  }

  public getVehicle(vehicleFilter: RenewVehicleFilter): Observable<RenewVehicle[]> {
    return this.RenewVehicleRepository.getVehicle(vehicleFilter);
  }

  public renewVehicle(loJackId: number[]): Observable<RenewVehicleResponse[]> {
    return this.RenewVehicleRepository.renewVehicle(loJackId);
  }

  public cancelVehicle(loJackId: number[]): Observable<RenewVehicleResponse[]> {
    return this.RenewVehicleRepository.cancelVehicle(loJackId);
  }

  public getVehicleReport(operationId: number): void {
    this.RenewVehicleRepository.getVehicleReport(operationId).pipe(first()).subscribe(this.fileHandlerService.openPdfInNewTab);
  }
}
